module.exports = __webpack_public_path__ + "static/media/sad200h.4b87220d.png";